import {
  formatValueWithMiddlewares,
  checkForNA,
  applySuffix,
  createKpiTileItem,
  appendPercentage,
} from '../../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { promotionsSaved, promotionsSavedDelta } = data;

    return createKpiTileItem(
      'Promotions Saved',
      formatValueWithMiddlewares(promotionsSaved, [checkForNA, applySuffix]),
      {
        isPositiveValue: promotionsSavedDelta > 0,
        text: formatValueWithMiddlewares(promotionsSavedDelta, [
          checkForNA,
          appendPercentage,
        ]).toString(),
        sideLabel: '',
        showArrow: promotionsSavedDelta !== 0,
      }
    );
  },
};
